import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import ConceptSection from "@/pages/home/components/ConceptSection";
import RegionSection from "@/pages/home/components/RegionSection";
import ThemeSection from "@/pages/home/components/ThemeSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 font-body">
      <SiteNav />
      <main>
        <Hero />
        <ConceptSection />
        <RegionSection />
        <ThemeSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}